// extracted by mini-css-extract-plugin
module.exports = {"table":"AddAttributes_table__3abTX","container":"AddAttributes_container__2aCkS","chip":"AddAttributes_chip__2zzKm","selected":"AddAttributes_selected__2ut5O"};